export enum EmailType {
    SUPPORT,
    ON_CLICK_BUY,
}
